import { CSSProperties } from 'react';

import { BRAND_ASSETS_BASE } from '../../constants';

interface Props {
  className?: string;
  style?: CSSProperties;
}

export const Logo = (p: Props) => {
  return (
    <img
      className={p.className || 'logo'}
      style={p.style}
      src={`${BRAND_ASSETS_BASE}/images/logo.png`}
      alt="MediaInbox logo"
    />
  );
};
